import Tabs, { Tab } from '@storeblocks/tabs';
import { RawHtmlFromTrustedSource } from '../../shared/components/RawHtmlFromTrustedSource';

type Content = {
  title: string;
  valueList: string[];
};

type TabbedContentProps = {
  title?: string;
  description: string;
  content: Array<Content>;
  selected: number;
  onChange: (id: number) => void;
};

export const TabbedContent = ({
  title,
  description,
  content,
  selected,
  onChange
}: TabbedContentProps) => {
  return (
    <section>
      {title && (
        <header style={{ marginBottom: '8px' }}>
          {/* eslint-disable-next-line jsx-a11y/role-has-required-aria-props */}
          <span role="heading" style={{ fontWeight: 'bold' }}>
            {title}
          </span>
        </header>
      )}
      <Tabs
        activeTabId={`${selected}`}
        description={description}
        onChange={(_, id) => onChange(+id)}
        style={{ marginTop: 4 }}
      >
        {content.map(({ title: tabTitle, valueList: tabValueList }, id) => (
          <Tab
            key={tabTitle}
            id={`${id}`}
            label={tabTitle}
            style={{ margin: 24, paddingBottom: 24 }}
          >
            {tabValueList.map(tabValue => (
              <RawHtmlFromTrustedSource key={tabValue} html={tabValue} />
            ))}
          </Tab>
        ))}
      </Tabs>
    </section>
  );
};
